import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import { alpha } from '@mui/material/styles';
import ManualScreenshot from './ManualScreenshot';
import { TipBox, NoteBox, WarnBox, StepList, BulletList, SectionHeading } from './ManualHelpers';
import useManualPalette from '../../hooks/useManualPalette';

const ManualChapterView = ({ chapter, chapterIndex, imageOverrides = {} }) => {
  const MP = useManualPalette();
  return (
    <Box
      id={`chapter-${chapter.id}`}
      sx={{ mb: 5, pageBreakBefore: chapterIndex > 0 ? 'always' : 'auto' }}
    >
      {/* Chapter heading */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          mb: 3,
          pb: 1.5,
          borderBottom: `3px solid ${MP.deepBlue}`,
        }}
      >
        <Box
          sx={{
            background: `linear-gradient(135deg, ${MP.deepBlue}, ${MP.blue})`,
            color: MP.yellow,
            borderRadius: 2,
            width: 44,
            height: 44,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 800,
            fontSize: '1rem',
            flexShrink: 0,
            boxShadow: `0 2px 8px ${alpha(MP.deepBlue, 0.4)}`,
          }}
        >
          {chapterIndex + 1}
        </Box>
        <Typography variant="h5" fontWeight={800} sx={{ color: MP.textPrimary }}>
          {chapter.title}
        </Typography>
      </Box>

      {chapter.sections.map((section, sIdx) => {
        const imageData = imageOverrides[section.id] || section.image;
        return (
          <Box key={section.id} sx={{ mb: 3.5 }}>
            <SectionHeading number={`${chapterIndex + 1}.${sIdx + 1}`} title={section.title} />

            {section.body && (
              <Typography variant="body2" sx={{ mb: 1.5, lineHeight: 1.8, color: MP.bodyText }}>
                {section.body}
              </Typography>
            )}

            {section.steps && <StepList steps={section.steps} />}
            {section.items && <BulletList items={section.items} />}

            {section.tip     && <TipBox>{section.tip}</TipBox>}
            {section.note    && <NoteBox>{section.note}</NoteBox>}
            {section.warning && <WarnBox>{section.warning}</WarnBox>}

            {imageData && (
              <ManualScreenshot src={imageData.src} caption={imageData.caption} alt={section.title} />
            )}
          </Box>
        );
      })}

      <Divider sx={{ mt: 4, borderColor: alpha(MP.deepBlue, 0.15) }} />
    </Box>
  );
};

export default ManualChapterView;
